<script>
    import { fly } from "svelte/transition";
    import { EncounterSidePanelProps } from "../../../stores";
    import { closeViewEncounterSidePanel } from "../../PatientEncounter/helpers/encounterHelper.svelte";
    import ViewPatientEncounter from "../../PatientEncounter/ViewPatientEncounter.svelte";
    import EditSection from "../../PatientEncounter/components/EditSection.svelte";
    import CreateSection from "../../PatientEncounter/components/CreateSection.svelte";

    let showPanel = false;

    $: if (
        $EncounterSidePanelProps &&
        ($EncounterSidePanelProps.id || (!$EncounterSidePanelProps.id && $EncounterSidePanelProps.type == "create")) &&
        isValidPanelType
    ) {
        showPanel = true;
    } else closePanel();

    $: if (showPanel) enableCloseWithEsc();

    $: isValidPanelType =
        $EncounterSidePanelProps &&
        $EncounterSidePanelProps.type &&
        ["view", "edit", "duplicate", "create"].includes($EncounterSidePanelProps.type);

    const enableCloseWithEsc = () => {
        document.onkeydown = (e) => {
            if (e.key === "Escape") closePanel();
        };
    };

    const closePanel = () => {
        $EncounterSidePanelProps.shouldTriggerCloseFunction &&
            $EncounterSidePanelProps.onCloseFunction();
        closeViewEncounterSidePanel();
        showPanel = false;
    };

    const getTitle = () => {
        if ($EncounterSidePanelProps.type == "view") return "View Encounter";
        if ($EncounterSidePanelProps.type == "edit") return "Edit Encounter";
        if ($EncounterSidePanelProps.type == "duplicate") return "Duplicate Encounter";
        if ($EncounterSidePanelProps.type == "create") return "Create Encounter";
        return "";
    };
</script>

{#if showPanel}

    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div class="overlay" on:click={closePanel} />

    <div class="flex flex-col side-panel-container flex-1 bg-white z-1000 rounded-xl">
        <div class="flex w-full items-center justify-between mb-4 font-medium text-lg rounded-tl-xl rounded-tr-xl header-margin py-3 pl-6 pr-1 text-[#fff] flex-0 bg-[#8a3ed7] px-6 py-3 min-h-[50px]">
            <div>
                {getTitle()}
            </div>
            <button
                class="btn btn-circle btn-sm btn-ghost mr-2"
                on:click={closePanel}
            >
                <i class="fa fa-times" aria-hidden="true"></i>
            </button>
        </div>

        <div
            class="flex flex-1 flex-col w-full px-4 py-4 font-normal overflow-y-auto text-[#6F726C]"
        >
            {#if $EncounterSidePanelProps.type == "view"}
                <ViewPatientEncounter
                    params={$EncounterSidePanelProps}
                    isFromCalendarList
                />
            {:else if $EncounterSidePanelProps.type == "edit"}
                <EditSection
                    patientEncounterId={$EncounterSidePanelProps.id}
                    isFromCalendarList
                />
            {:else if $EncounterSidePanelProps.type == "duplicate"}
                <EditSection
                    patientEncounterId={$EncounterSidePanelProps.id}
                    isEditDuplicate
                    isFromCalendarList
                />
            {:else if $EncounterSidePanelProps.type == "create"}
                <CreateSection
                    params={$EncounterSidePanelProps}
                    isFromCalendarList
                />
            {/if}
        </div>
    </div>
{/if}

<style>
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.25);
        z-index: 1001;
        
    }

    .side-panel-container {
        position: absolute;
        width: 90%;
        height: 95%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 1002;
        border: 2px solid #8a3ed777;
        box-shadow: 0 25px 50px -12px rgba(138, 62, 215, 0.5) !important;
    }
</style>
